import { GameUI } from "game/gameUI/GameUI";
import { translate } from "game/translate"
import { Popups } from "ui/types/popups";

export const TutorialRestartPopup = () => {
    const handleCloseBtnClick = () => {
        GameUI.closePopup(Popups.TUTORIAL_RESTART);
        document.dispatchEvent(new CustomEvent('closeModal', { detail: { id: 'tutorial_restart', confirm: false, button: document.querySelector('.close_btn') } }));
    }

    const handleRestartBtnClick = () => {
        GameUI.closePopup(Popups.TUTORIAL_RESTART, true);
        document.dispatchEvent(new CustomEvent('closeModal', { detail: { id: 'tutorial_restart', confirm: true } }));
    }
    
    return (
        <div id="tutorial_restart" role="tooltip" className="modals_area active">
            <div className="wrapper">
                <button type="button" className="close_btn close" onClick={handleCloseBtnClick}></button>
                <div className="text_content">
                    <span className="modals_area-title">{translate("tutorial_restart_title")}</span>
                    <p className="modals_area-text">{translate("tutorial_restart_text")}</p>
                    <button type="button" className="modals_area-btn" onClick={handleRestartBtnClick}>{translate("tutorial_restart_button")}</button>
                </div>
            </div>
        </div>
    )
}




